import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

const useQuestionOptions = ({ optionIds, extraFields } = {}) => {
  const query = gql`
    query UseQuestionOptions($optionIds: [ID!]!) {
      options(ids: $optionIds) {
        id
        title
        ${extraFields || ''}
      }
    }
  `;

  const { data: { options } = {}, ...rest } = useQuery(query, {
    variables: { optionIds },
    skip: !optionIds?.length,
  });

  return {
    options,
    ...rest,
  };
};

export default useQuestionOptions;
